import { useEffect, useState } from 'react';
import { getLeadFormConfig, LeadFormConfig } from '@/app/utilities/apis';

// One request per model per page load — a lead button can be opened many times.
const configCache = new Map<string, Promise<LeadFormConfig>>();

/**
 * Returns the lead form config for `carId` (model id): whether the form must
 * collect email and whether the nearby-dealer step follows a confirmed lead.
 * `loading` is true until the config for the current `carId` has resolved.
 */
export function useLeadFormConfig(carId?: string | null) {
    const [state, setState] = useState<{ carId?: string | null; emailRequired: boolean; dealerSelectionEnabled: boolean }>({
        carId: undefined,
        emailRequired: false,
        dealerSelectionEnabled: false,
    });

    useEffect(() => {
        if (!carId) return;
        let cancelled = false;

        let request = configCache.get(carId);
        if (!request) {
            request = getLeadFormConfig(carId);
            configCache.set(carId, request);
        }
        request.then((config) => {
            if (!cancelled) {
                setState({ carId, emailRequired: config.email_required, dealerSelectionEnabled: config.dealer_selection_enabled });
            }
        });

        return () => { cancelled = true; };
    }, [carId]);

    const resolved = !carId || state.carId === carId;
    return {
        emailRequired: resolved && !!carId && state.emailRequired,
        dealerSelectionEnabled: resolved && !!carId && state.dealerSelectionEnabled,
        loading: !resolved,
    };
}
